export default "__VITE_ASSET__$EKlSJTs__"